module.exports = __webpack_public_path__ + "img/personal.d448cdd1.png";